import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "menu-panel" }
const _hoisted_2 = { class: "menu-heading" }
const _hoisted_3 = { id: "site-menu-title" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = { class: "mobile-navigation menu-section" }
const _hoisted_7 = {
  key: 1,
  class: "material-icons",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "account-copy" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "menu-section" }
const _hoisted_11 = {
  class: "material-icons",
  "aria-hidden": "true"
}
const _hoisted_12 = {
  key: 1,
  class: "menu-section"
}
const _hoisted_13 = { class: "menu-section" }
const _hoisted_14 = {
  key: 2,
  class: "menu-section"
}
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = ["lang"]
const _hoisted_17 = { class: "theme-slot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_LocaleLink = _resolveComponent("LocaleLink")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ThemeToggle = _resolveComponent("ThemeToggle")!
  const _component_DevPanel = _resolveComponent("DevPanel")!
  const _component_LanguageChoices = _resolveComponent("LanguageChoices")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.open,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.open) = $event)),
    eager: "",
    class: "site-menu-overlay",
    "max-width": "360",
    "aria-labelledby": "site-menu-title",
    onAfterEnter: _ctx.resetMenu
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("button", _mergeProps({
        type: "button",
        class: "menu-trigger"
      }, props), [
        _createTextVNode(_toDisplayString(_ctx.$t('menu.menu')), 1),
        _cache[12] || (_cache[12] = _createElementVNode("span", {
          class: "material-icons",
          "aria-hidden": "true"
        }, "menu", -1))
      ], 16)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          (_ctx.languageView)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                ref: "languageBack",
                type: "button",
                class: "back-menu",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLanguages(false)))
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { "aria-hidden": "true" }, "‹", -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('menu.back')), 1)
              ], 512))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.languageView ? _ctx.languageLabel : _ctx.$t('menu.menu')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "close-menu",
            "aria-label": _ctx.$t('menu.close'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = false))
          }, _cache[14] || (_cache[14] = [
            _createElementVNode("span", {
              class: "material-icons",
              "aria-hidden": "true"
            }, "close", -1)
          ]), 8, _hoisted_4)
        ]),
        _withDirectives(_createElementVNode("nav", {
          ref: "menuContent",
          "aria-label": _ctx.$t('menu.menu'),
          class: "menu-content"
        }, [
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('menu.account')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "menu-item account-item",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openProfile && _ctx.openProfile(...args)))
            }, [
              (_ctx.$store.state.profile)
                ? (_openBlock(), _createBlock(_component_Avatar, {
                    key: 0,
                    avatarID: _ctx.$store.state.profile.avatar,
                    alt: ""
                  }, null, 8, ["avatarID"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "person")),
              _createElementVNode("span", _hoisted_8, [
                (_ctx.$store.state.profile)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_9, _toDisplayString(_ctx.$store.state.profile.name), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.$store.state.profile ? 'menu.myProfile' : 'menu.signInRegister')), 1)
              ])
            ]),
            _createVNode(_component_LocaleLink, {
              to: { name: 'wiki' },
              class: _normalizeClass(["menu-item", { active: _ctx.active('/wiki/') }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.open = false))
            }, {
              default: _withCtx(() => [
                _cache[15] || (_cache[15] = _createElementVNode("span", {
                  class: "material-icons",
                  "aria-hidden": "true"
                }, "menu_book", -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('menu.rulesRoles')), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          (_ctx.$store.state.profile)
            ? (_openBlock(), _createBlock(_component_LocaleLink, {
                key: 0,
                to: { name: 'profile', hash: '#stickers' },
                class: "menu-item",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.open = false))
              }, {
                default: _withCtx(() => [
                  _cache[16] || (_cache[16] = _createElementVNode("span", {
                    class: "material-icons",
                    "aria-hidden": "true"
                  }, "collections_bookmark", -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t('cosmeticRewards.collectionNav')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_10, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('menu.playersResults')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultLinks, (item) => {
              return (_openBlock(), _createBlock(_component_LocaleLink, {
                key: item.name,
                to: { name: item.name },
                class: _normalizeClass(["menu-item", { active: _ctx.active(item.path) }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.open = false))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(item.icon), 1),
                  _createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            }), 128))
          ]),
          (_ctx.$store.state.profile?.isAdmin)
            ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'adminBots' },
                  class: "menu-item",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.open = false))
                }, {
                  default: _withCtx(() => [
                    _cache[17] || (_cache[17] = _createElementVNode("span", {
                      class: "material-icons",
                      "aria-hidden": "true"
                    }, "analytics", -1)),
                    _createTextVNode(_toDisplayString(_ctx.$t('aiArena.botDashboard')), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_13, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('menu.aboutAvalon')), 1),
            _createVNode(_component_LocaleLink, {
              to: { name: 'about' },
              class: _normalizeClass(["menu-item", { active: _ctx.active('/about/') }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.open = false))
            }, {
              default: _withCtx(() => [
                _cache[18] || (_cache[18] = _createElementVNode("span", {
                  class: "material-icons",
                  "aria-hidden": "true"
                }, "info", -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('menu.about')), 1)
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_LocaleLink, {
              to: { name: 'support' },
              class: _normalizeClass(["menu-item", { active: _ctx.active('/support/') }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.open = false))
            }, {
              default: _withCtx(() => [
                _cache[19] || (_cache[19] = _createElementVNode("span", {
                  class: "material-icons",
                  "aria-hidden": "true"
                }, "favorite", -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('about.supportProject')), 1)
              ]),
              _: 1
            }, 8, ["class"]),
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "menu-social-links" }, [
              _createElementVNode("a", {
                href: "https://discord.gg/DR9cEDDNdN",
                target: "_blank",
                rel: "noopener noreferrer"
              }, [
                _createTextVNode("Discord "),
                _createElementVNode("span", { "aria-hidden": "true" }, "↗")
              ]),
              _createElementVNode("a", {
                href: "https://github.com/Razdva122/avalon",
                target: "_blank",
                rel: "noopener noreferrer"
              }, [
                _createTextVNode("GitHub "),
                _createElementVNode("span", { "aria-hidden": "true" }, "↗")
              ])
            ], -1))
          ]),
          (_ctx.tipsSession.available && !_ctx.tipsSession.enabled)
            ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "menu-item",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.enableTips && _ctx.enableTips(...args)))
                }, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", {
                    class: "material-icons",
                    "aria-hidden": "true"
                  }, "info_outline", -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t('beginnerTips.enable')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", {
            class: "menu-section compact-settings",
            "aria-label": _ctx.$t('menu.settings')
          }, [
            _createElementVNode("button", {
              ref: "languageTrigger",
              type: "button",
              class: "language-trigger",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showLanguages(true)))
            }, [
              _cache[22] || (_cache[22] = _createElementVNode("svg", {
                class: "language-symbol",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.6",
                "aria-hidden": "true"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "12",
                  r: "9"
                }),
                _createElementVNode("ellipse", {
                  cx: "12",
                  cy: "12",
                  rx: "4",
                  ry: "9"
                }),
                _createElementVNode("path", { d: "M3 12h18" })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.languageLabel), 1),
              _createElementVNode("span", {
                class: "current-language",
                lang: _ctx.currentLanguage
              }, _toDisplayString(_ctx.currentLanguageTitle), 9, _hoisted_16),
              _cache[23] || (_cache[23] = _createElementVNode("span", { "aria-hidden": "true" }, "›", -1))
            ], 512),
            _createElementVNode("div", _hoisted_17, [
              (_ctx.open)
                ? (_openBlock(), _createBlock(_component_ThemeToggle, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_DevPanel)
          ], 8, _hoisted_15)
        ], 8, _hoisted_5), [
          [_vShow, !_ctx.languageView]
        ]),
        (_ctx.languageView)
          ? (_openBlock(), _createBlock(_component_LanguageChoices, {
              key: 0,
              "current-language": _ctx.currentLanguage,
              neutral: _ctx.neutralPage,
              onSelect: _ctx.selectLanguage,
              onRemember: _ctx.rememberChoice
            }, null, 8, ["current-language", "neutral", "onSelect", "onRemember"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onAfterEnter"]))
}